import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UUID, VersionService} from '@nh/angular-tses';
import {environment} from 'environments/environment';
import {map} from 'rxjs/operators';

interface SerialisedVersionTag {
  versionId: string;
  fragmentId: string;
  fragmentVersionId: string;
  createdBy: string;
  name: string;
  createdAt: number;
  availableToReview: boolean;
  availableForCommenting: boolean;
  userDiscussionsOnly: boolean;
  versionTagType: string;
}

export interface Snapshot {
  id: UUID;
  departureId: UUID;
  name: string;
  createdBy?: UUID;
  createdAt?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SnapshotService {
  private static readonly VERSION_ENDPOINT: string = `${environment.tsesConfig.apiHost}/versions`;

  constructor(private versionService: VersionService, private http: HttpClient) {}

  public getSnapshotTimestamp(): number {
    return this.versionService.getVersionTimestamp();
  }

  public setSnapshotTimestamp(timeStamp: number): void {
    this.versionService.setVersionTimestamp(timeStamp);
  }

  public viewingSnapshot(): boolean {
    return this.versionService.viewingVersion();
  }

  public getSnapshots(departureId: UUID): Promise<Snapshot[]> {
    const url: string = SnapshotService.VERSION_ENDPOINT + '/search/withFragmentId';
    const params: {[param: string]: string | string[]} = {fragmentId: departureId.value};

    return this.http
      .get(url, {params})
      .pipe(
        map((json: any) => {
          return json._embedded.versionTags
            .map((versionTag: SerialisedVersionTag) => {
              return {
                id: UUID.orNull(versionTag.versionId),
                departureId: UUID.orNull(versionTag.fragmentId),
                name: versionTag.name,
                createdBy: UUID.orNull(versionTag.createdBy),
                createdAt: versionTag.createdAt
              };
            })
            .reverse();
        })
      )
      .toPromise();
  }
}
